module.exports = __webpack_public_path__ + "img/KIDIWI-services-gradient.daf69400.svg";